import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import { NAVY, POPPINS } from '../studentStyles';

interface PhoneFrameProps {
    title?: string;
    onBack?: () => void;
    children: React.ReactNode;
}

// Centered phone-width column: reads as a mobile app on desktop, full-bleed on a phone.
export default function PhoneFrame({ title, onBack, children }: PhoneFrameProps) {
    return (
        <Box sx={{ width: '100%', maxWidth: 430, mx: 'auto', px: 2.5, pt: 3, pb: 6 }}>
            {(title || onBack) && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                    {onBack && (
                        <IconButton aria-label="Back" onClick={onBack} sx={{ ml: -1, color: NAVY }}>
                            <ArrowBackRoundedIcon />
                        </IconButton>
                    )}
                    {title && (
                        <Typography sx={{ fontFamily: POPPINS, fontWeight: 600, fontSize: 22, color: NAVY }}>
                            {title}
                        </Typography>
                    )}
                </Box>
            )}
            {children}
        </Box>
    );
}
